import React from 'react';
import './historical-report-tab-buttons.css';
import ButtonsForTabs from '../../../../Button/ButtonsForTabs';
import { ButtonConfig } from '../../../../Tabs/MainFrameTab';

interface IHRTabButtons {
    Redraw: () => void;
    SearchCondition: () => void;
}

function HRTabButtons(props: IHRTabButtons) {
    const { Redraw, SearchCondition } = props;

    const tabRef = React.useRef<HTMLDivElement>(null);

    const buttons: ButtonConfig[] = [
        {
            title: 'Open Other Folder',
            className: 'open-other-folder',
            style: {
                margin: '0px 8px'
            }
        },
        {
            title: 'Print',
            className: 'print',
            style: {
                marginRight: '8px'
            }
        },
        {
            title: 'Redraw',
            className: 'redraw',
            style: {
                marginRight: '8px'
            },
            action: () => {
                Redraw();
            }
        },
        {
            title: 'Search Condition',
            className: 'search-condition',
            action: () => {
                SearchCondition();
            }
        },
        {
            title: 'Stop Searching',
            className: 'stop-searching',
            style: {
                marginRight: '8px'
            }
        },
        {
            title: 'Save',
            className: 'save',
            style: {
                marginRight: '8px'
            }
        }
    ];

    return (
        <>
            <hr style={{ margin: '3px 0px 0px 0px' }}></hr>
            <div
                style={{
                    height: '40px',
                    background: '#d4d0c8',
                    display: 'flex',
                    alignItems: 'center'
                }}
                className="historical-report-tabs"
                ref={tabRef}>
                {buttons.map((button: any, index: number) => (
                    <ButtonsForTabs
                        key={index}
                        title={button.title}
                        className={button.className}
                        style={button.style}
                        onClick={() => {
                            if (button.action) button.action();
                        }}
                    />
                ))}
                <div style={{ border: '1px inset', height: '90%' }}></div>
            </div>
        </>
    );
}

export default HRTabButtons;
